import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { TaskState } from '~/state/atoms/jobAtoms';

/**
 * Transforms a task into GenerationModelDetails format for processCreatedFiles
 * @param task - The task state containing model information
 * @param provenanceTaskId - The connector task the results can be attributed
 * to when saved; omitted where the connector does not attribute saved
 * datasets to the task.
 * @returns GenerationModelDetails object with proper fallback values
 */
export function transformTaskToGenerationModel(
    task?: TaskState,
    provenanceTaskId?: string
): GenerationModelDetails | undefined {
    if (!task?.model) {
        return undefined;
    }

    return {
        name: task.model.name,
        label: task.model.label,
        version: task.model.version,
        isLatest: task.model.isLatest,
        customizationName: task.customizationName,
        inputModalities: task.model.inputModalities,
        outputModality: task.model.outputModality,
        provenanceTaskId,
        resultCarriesInputStructures:
            'includeStructureSet' in task && !!task.includeStructureSet,
    };
}
